// extracted by mini-css-extract-plugin
export default {"genericCard":"Go-z","inline":"Ho-z","mastercard":"Io-z","discover":"Jo-z","visa":"Ko-z","amex":"Lo-z","active":"Mo-z"};